import _toConsumableArray from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _get from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { MediaChromeButton } from "./media-chrome-button.js";
import { globalThis, document } from "./utils/server-safe-globals.js";
import { MediaUIEvents, MediaUIAttributes } from "./constants.js";
import { getNumericAttr, setNumericAttr } from "./utils/element-utils.js";
import { verbs } from "./labels/labels.js";
import { getSlotted, updateIconText } from "./utils/element-utils.js";
var Attributes = {
  SEEK_OFFSET: "seekoffset"
};
var DEFAULT_SEEK_OFFSET = 30;
var forwardIcon = "<svg aria-hidden=\"true\" viewBox=\"0 0 20 24\"><defs><style>.text{font-size:8px;font-family:Arial-BoldMT, Arial;font-weight:700;}</style></defs><text class=\"text value\" transform=\"translate(8.9 19.87)\">".concat(DEFAULT_SEEK_OFFSET, "</text><path d=\"M10 6V3l5.61 4L10 10.94V8a5.54 5.54 0 0 0-1.9 10.48v2.12A7.5 7.5 0 0 1 10 6Z\"/></svg>");
var slotTemplate = document.createElement("template");
slotTemplate.innerHTML = "\n  <slot name=\"icon\">".concat(forwardIcon, "</slot>\n");
var DEFAULT_TIME = 0;

var MediaSeekForwardButton = /*#__PURE__*/function (_MediaChromeButton) {
  _inherits(MediaSeekForwardButton, _MediaChromeButton);

  var _super = _createSuper(MediaSeekForwardButton);

  function MediaSeekForwardButton() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MediaSeekForwardButton);

    return _super.call(this, _objectSpread({
      slotTemplate: slotTemplate
    }, options));
  }

  _createClass(MediaSeekForwardButton, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.seekOffset = getNumericAttr(this, Attributes.SEEK_OFFSET, DEFAULT_SEEK_OFFSET);

      _get(_getPrototypeOf(MediaSeekForwardButton.prototype), "connectedCallback", this).call(this);
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, _oldValue, newValue) {
      if (attrName === Attributes.SEEK_OFFSET) {
        this.seekOffset = getNumericAttr(this, Attributes.SEEK_OFFSET, DEFAULT_SEEK_OFFSET);
      }

      _get(_getPrototypeOf(MediaSeekForwardButton.prototype), "attributeChangedCallback", this).call(this, attrName, _oldValue, newValue);
    }
  }, {
    key: "seekOffset",
    get: function get() {
      return getNumericAttr(this, Attributes.SEEK_OFFSET, DEFAULT_SEEK_OFFSET);
    },
    set: function set(value) {
      setNumericAttr(this, Attributes.SEEK_OFFSET, value);
      this.setAttribute("aria-label", verbs.SEEK_FORWARD_N_SECS({
        seekOffset: this.seekOffset
      }));
      updateIconText(getSlotted(this, "icon"), this.seekOffset);
    }
  }, {
    key: "mediaCurrentTime",
    get: function get() {
      return getNumericAttr(this, MediaUIAttributes.MEDIA_CURRENT_TIME, DEFAULT_TIME);
    },
    set: function set(time) {
      setNumericAttr(this, MediaUIAttributes.MEDIA_CURRENT_TIME, time);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var detail = this.mediaCurrentTime + this.seekOffset;
      var evt = new globalThis.CustomEvent(MediaUIEvents.MEDIA_SEEK_REQUEST, {
        composed: true,
        bubbles: true,
        detail: detail
      });
      this.dispatchEvent(evt);
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return [].concat(_toConsumableArray(_get(_getPrototypeOf(MediaSeekForwardButton), "observedAttributes", this)), [MediaUIAttributes.MEDIA_CURRENT_TIME, Attributes.SEEK_OFFSET]);
    }
  }]);

  return MediaSeekForwardButton;
}(MediaChromeButton);

if (!globalThis.customElements.get("media-seek-forward-button")) {
  globalThis.customElements.define("media-seek-forward-button", MediaSeekForwardButton);
}

var media_seek_forward_button_default = MediaSeekForwardButton;
export { Attributes, media_seek_forward_button_default as default };